import type { Domains } from "./direct-access";

// HaxeのInt64表現
declare class HaxeInt64 {
  high: number;
  low: number;
}

/** directのID表現のうち、_${high}_${low} になっているものを表す */
export type DirectHighLowIdStr = string;

/** directのID表現のうち、Int64をそのまま文字列化したもの */
export type DirectIdStr = string;

/** directのInt64形式 */
export type DirectInt64 = HaxeInt64;

export interface IDirectUserInfo {
  id: string; //!< UserPool の user id
  name: string; //!< direct の display name
  email: string; //!< direct の email(管理ユーザの場合は無い)
  userId: string; //!< direct の user id
  domains: Domains; //!< direct の 所属組織ID一覧
  image: string; //!< ユーザープロフィール画像。未設定の場合は空文字
}
export const createDummyDirectUser = (): IDirectUserInfo => {
  return { id: "", name: "", email: "", userId: "", domains: [], image: "" };
};
